module.exports = __webpack_public_path__ + "static/media/open_box.429910a7.jpg";